/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Key_Big_Ape_HackInputs */

const fr_key_big_ape_hack = /** @type {(inputs: Key_Big_Ape_HackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission mise à jour`)
};

/**

* @param {Key_Big_Ape_HackInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const key_big_ape_hack = /** @type {((inputs?: Key_Big_Ape_HackInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Key_Big_Ape_HackInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_key_big_ape_hack(inputs)
});